import gql from 'graphql-tag';


const MUTATION_ADD_STORE_LOGO = gql`
	mutation AddStoreLogo($storeID: String!, $file: Upload!) {
		addStoreLogo(storeID: $storeID, file: $file)
	}
`;

export default MUTATION_ADD_STORE_LOGO;